import React from 'react';
import {
  FiMessageCircle,
  FiFileText,
  FiPenTool,
  FiTrendingUp,
  FiPackage,
  FiRefreshCw
} from 'react-icons/fi';
import './Process.css';

const Process = () => {
  const steps = [
    { step: 1, title: '需求沟通', desc: '1-2天', icon: <FiMessageCircle /> },
    { step: 2, title: '方案制定', desc: '3-5天', icon: <FiFileText /> },
    { step: 3, title: '合同签订', desc: '1-2天', icon: <FiPenTool /> },
    { step: 4, title: '项目实施', desc: '根据项目规模', icon: <FiTrendingUp /> },
    { step: 5, title: '成果交付', desc: '标准交付时间', icon: <FiPackage /> },
    { step: 6, title: '后续服务', desc: '持续支持', icon: <FiRefreshCw /> }
  ];

  return (
    <section className="process-section">
      <div className="container">
        <h2 className="section-title">服务流程</h2>
        <p className="section-subtitle">标准化流程，高效服务</p>
        <div className="process-timeline">
          {steps.map((item, index) => (
            <div key={index} className="process-step">
              <div className="step-icon">{item.icon}</div>
              <div className="step-content">
                <div className="step-number">{item.step}</div>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
              {index < steps.length - 1 && <div className="step-arrow">→</div>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;

